import { render } from "./System.vue?vue&type=template&id=2b51cd83"
import script from "./System.vue?vue&type=script&lang=ts"
export * from "./System.vue?vue&type=script&lang=ts"

import "./System.vue?vue&type=style&index=0&id=2b51cd83&lang=scss"
script.render = render

export default script